export default __webpack_public_path__ + "static/media/Tasset of Righteous Smiting.66c6c9ef.jpg";